import React from "react";
import line from "../assets/line.png";
import First from "../assets/First.jpg";
import service1 from "../assets/service1.png";
import service2 from "../assets/service2.png";
import service3 from "../assets/service3.png";
import service4 from "../assets/service4.png";
import service5 from "../assets/service5.png";
import service6 from "../assets/service6.png";
 import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

 
const HisPage = () => {
  return (
    <div className="min-h-screen scroll-smooth">
{/* Hero Section with Video Background */}
<section className="relative h-[60vh] flex items-center justify-center text-white overflow-hidden">
  {/* 🎥 Video Background */}
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/Product780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />
  {/* 🌫️ Transparent Overlay */}
<div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />


  <div className="max-w-7xl mx-auto px-6 w-full z-10 flex flex-col items-center text-center">
    <h1 className="text-5xl md:text-6xl lg:text-6xl text-white font-bold">WISE HIS</h1>
    <h2
      className="font-extrabold text-transparent"
      style={{
        fontFamily: "Calibri, sans-serif",
        WebkitTextStroke: "1.8px #ffffff",
        fontSize: "4.5rem",
        letterSpacing: "0.04em",
        lineHeight: "1.05",
        whiteSpace: "nowrap",
      }}
    >
      FUTURE OF HOSPITAL MANAGEMENT
    </h2>
  </div>
</section>

{/* Vision Section */}
<section className="pt-24 pb-20 px-6 bg-white flex flex-col items-center justify-center snap-start w-full !h-auto">
  <div className="max-w-6xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
   
    {/* Left Side - Paragraph */}
    <div>
     <p className="text-gray-700 leading-relaxed text-base md:text-lg text-justify">
  <span className="font-bold text-gray-900">WISE HIS (Hospital Information System)</span> is an
  <span className="font-bold text-gray-900"> AI-powered, cloud-ready platform</span> that redefines hospital
  management by integrating advanced automation, real-time data access, and intelligent decision
  support. Designed to enhance operational efficiency and elevate patient care,
  <span className="font-bold text-gray-900"> WISE HIS</span> seamlessly connects
  <span className="font-bold text-gray-900"> clinical, administrative, and financial workflows</span> into a
  single, unified system. Whether it’s
  <span className="font-bold text-gray-900"> patient registration, appointment scheduling, diagnostics, billing, or compliance tracking</span>,
  <span className="font-bold text-gray-900"> WISE HIS</span> streamlines every aspect of hospital operations.
</p>

    </div>
 
    {/* Right Side - Image */}
    <div className="flex justify-center">
      <img
        src={service1}
        alt="WISE HIS illustration"
        className="max-w-sm md:max-w-md lg:max-w-lg object-contain"
      />
    </div>
 
  </div>
</section>
<section className="bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white w-full py-20 h-auto flex items-center justify-center">
  <div className="max-w-6xl w-full px-6">
   
    {/* Heading (Left Aligned) */}
    <div className="relative inline-block">
      <h2 className="text-white text-4xl font-semibold">
        Key Features of <span style={{ color: "#0077cc" }}>WISE HIS</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>

    {/* Functionality Points (Centered Grid) */}
    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-12 w-full max-w-4xl mx-auto">
      <ul className="space-y-6 list-disc list-inside marker:text-blue-400 text-xl leading-relaxed">
        {[
          'Centralized Patient Records',
          'Automated Workflow Management',
          'Real-Time Analytics & Insights',
        ].map((item, index) => (
          <li
            key={index}
            className="font-medium transition-transform duration-300 hover:translate-x-2"
          >
            {item}
          </li>
        ))}
      </ul>

      <ul className="space-y-6 list-disc list-inside marker:text-blue-400 text-xl leading-relaxed">
        {[
          'Integrated Billing',
          'Interoperability & Compliance',
          'Enhanced Patient Experience',
        ].map((item, index) => (
          <li
            key={index}
            className="font-medium transition-transform duration-300 hover:translate-x-2"
          >
            {item}
          </li>
        ))}
      </ul>
    </div>

  </div>
</section>


<section className="w-full bg-white py-20 !h-auto snap-start">
  <div className="max-w-6xl w-full px-6 mx-auto flex flex-col">
   
    {/* Heading (Left Aligned) */}
    <div className="relative inline-block mb-6">
      <h2 className="text-black text-4xl font-semibold">
        Key Modules of <span style={{ color: "#0077cc" }}>WISE HIS</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>
{/* Paragraph (Clean & Neat Alignment) */}
<p
  className="text-gray-700 text-lg leading-relaxed max-w-4xl mx-auto text-center"
  style={{ fontFamily: "Calibri, sans-serif" }}
>
  <span className="font-semibold">WISE HIS</span> is designed as a{" "}
  <span className="font-semibold">modular and scalable platform</span>, ensuring that
  healthcare providers have access to the right tools for{" "}
  <span className="font-semibold">seamless hospital management</span>. Each module is built
  to address specific operational challenges, from{" "}
  <span className="font-semibold">patient care and clinical workflows</span> to{" "}
  <span className="font-semibold">financial management and compliance</span>. Discover how
  each module contributes to a{" "}
  <span className="font-semibold">smarter, more efficient, and patient-centric</span>{" "}
  healthcare system.
</p>


  </div>
</section>
<section className="w-full bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden px-6 sm:px-10 lg:px-20 py-20 !h-auto snap-start">
  <div className="max-w-6xl mx-auto flex flex-col justify-center">
   
    {/* Heading */}
    <div className="relative inline-block mb-8 md:ml-6 lg:ml-10">
      <h2 className="text-white text-4xl font-semibold text-center md:text-left">
        Patient <span style={{ color: "#0077cc" }}>Administration</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>
 
    {/* Content: Image + Paragraph */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center md:ml-6 lg:ml-10">
     
      {/* Left: Image */}
      <div className="flex justify-center md:justify-start">
        <img
          src={service2}
          alt="WISE HIS illustration"
          className="max-w-[80%] md:max-w-[85%] w-full object-contain"
        />
      </div>
 
      {/* Right: Paragraph */}
      <div className="flex flex-col justify-center">
        <p className="text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-200 text-justify">
          Efficient patient administration is the foundation of a well-functioning healthcare system.
          The <span className="font-semibold text-white">WISE HIS Patient Administration Module</span> is designed
          to streamline patient management, from registration and appointment scheduling to admissions,
          transfers, and discharge tracking. By integrating automated workflows and real-time data access,
          hospitals can ensure <span className="font-semibold text-white">seamless patient flow</span>, optimized
          resource allocation, and improved patient experience.
        </p>
      </div>
    </div>
  </div>
</section>

<section className="w-full bg-white text-black relative overflow-hidden px-6 sm:px-10 lg:px-16 py-20 snap-start !h-auto">
  <div className="max-w-5xl mx-auto flex flex-col justify-center w-full">

    {/* Heading */}
    <div className="relative inline-block mb-10 text-left w-fit md:ml-2 lg:ml-4">
      <h2 className="text-4xl font-bold inline-block">
        Key <span style={{ color: "#0077cc" }}>Features</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 w-full h-[6px] object-contain"
      />
    </div>

    {/* Features List */}
    <ul className="list-disc pl-8 space-y-10 text-xl leading-relaxed text-left text-[#0077cc] md:ml-2 lg:ml-4">
      
      <li>
        <p className="font-semibold text-black">Patient Registration:</p>
        <p className="text-gray-800">
          Capture comprehensive demographic details, SSN, insurance information, and biometric data
          to ensure accurate and secure patient records.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Appointment Scheduling:</p>
        <p className="text-gray-800">
          Optimize appointment management with a real-time scheduling system, enabling efficient
          time slot allocation, rescheduling, and cancellations for doctors and nurses.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">
          Patient Management &amp; ADT (Admission, Discharge, Transfer):
        </p>
        <p className="text-gray-800">
          Track patient movement from admission to discharge, ensuring efficient coordination across
          departments and real-time updates on patient status.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Bed &amp; Wards Management:</p>
        <p className="text-gray-800">
          Monitor hospital bed availability with an interactive graphical interface, allowing for
          efficient bed allocation, classification (ICU, PICU, SICU, Isolation), and maintenance tracking.
        </p>
      </li>
    </ul>

  </div>
</section>


<section className="w-full snap-start bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden px-6 sm:px-10 lg:px-16 py-20 !h-auto">
  <div className="max-w-6xl mx-auto flex flex-col w-full">
    
    {/* Heading */}
    <div className="relative inline-block mb-10 md:ml-6 lg:ml-10">
      <h2 className="text-white text-4xl font-semibold text-center md:text-left">
        Clinical <span style={{ color: "#0077cc" }}>Suite</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>

    {/* Content: Image + Paragraph */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center md:ml-6 lg:ml-10">
      
      {/* Left: Image */}
      <div className="flex justify-center md:justify-start items-center">
        <img
          src={service3}
          alt="WISE HIS illustration"
          className="max-w-[18rem] md:max-w-[20rem] lg:max-w-[22rem] w-full object-contain"
        />
      </div>

      {/* Right: Paragraph */}
      <div className="flex flex-col justify-center">
        <p className="text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-200 text-justify">
          Providing an integrated approach to patient care, the
          <span className="font-semibold text-white"> WISE HIS Clinical Suite </span>
          enhances coordination between healthcare providers.
          This module streamlines medical workflows by offering doctors and nurses a centralized
          platform to manage patient interactions, clinical documentation, and treatment plans,
          ensuring improved patient outcomes and operational efficiency.
        </p>
      </div>
    </div>
  </div>
</section>

<section className="w-full snap-start bg-white text-black relative overflow-hidden px-4 sm:px-6 lg:px-8 py-20 !h-auto">
  <div className="max-w-5xl mx-auto flex flex-col w-full">
    
    {/* Heading */}
    <div className="relative inline-block mb-10 text-left w-fit">
      <h2 className="text-4xl font-bold inline-block">
        Key <span style={{ color: "#0077cc" }}>Features</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>

    {/* Features List */}
    <ul className="list-disc pl-8 space-y-8 text-xl leading-relaxed text-left" style={{ color: "#0077cc" }}>
      <li>
        <p className="font-semibold text-black">Doctor’s Workbench</p>
        <p className="text-gray-800">
          Centralized interface for tracking patient history, updating EMRs, prescribing medications, and managing clinical notes.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Nursing Workbench</p>
        <p className="text-gray-800">
          Streamlined platform for nurses to coordinate patient care, manage tasks, and access real-time clinical data.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Order Entry (CPOE)</p>
        <p className="text-gray-800">
          Electronic system for physicians to place medication, lab, and diagnostic orders, reducing errors and improving efficiency.
        </p>
      </li>
    </ul>
  </div>
</section>
<section className="w-full snap-start bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden px-6 sm:px-10 lg:px-16 py-20 !h-auto">
  <div className="max-w-6xl mx-auto flex flex-col w-full">
    
    {/* Heading */}
   <div className="relative inline-block mb-10 text-left w-fit ml-10 md:ml-14 lg:ml-16">
  <h2 className="text-white text-4xl font-semibold">
    Additional <span style={{ color: "#0077cc" }}>Modules</span>
  </h2>
  <img
    src={line}
    alt="underline"
    className="absolute left-0 -bottom-2 h-[6px] object-contain"
  />
</div>


    {/* Content: Image + Paragraph */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
      
      {/* Left: Overlapping Images */}
      <div className="flex justify-center items-center relative">
        {/* Service 4 Background Image */}
        <img
          src={service4}
          alt="Service 4"
          className="max-w-sm md:max-w-sm w-full object-contain"
        />

        {/* Service 5 Overlay Image */}
        <img
          src={service5}
          alt="Service 5"
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                     max-w-[55%] w-full object-contain"
        />
      </div>

      {/* Right: Paragraph */}
      <div className="flex flex-col justify-center">
        <p className="text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-200 text-justify">
          Beyond core functionalities,
          <span className="font-semibold text-white"> WISE HIS </span>
          offers additional modules that enhance operational efficiency and financial management.
          These modules streamline finance, inventory, and procurement processes, ensuring seamless
          integration within the healthcare ecosystem.
        </p>
      </div>
    </div>
  </div>
</section>

<section className="w-full snap-start bg-white text-black relative overflow-hidden px-4 sm:px-6 lg:px-8 py-20 !h-auto">
  <div className="max-w-5xl mx-auto flex flex-col w-full">
    
    {/* Heading */}
    <div className="relative inline-block mb-10 text-left w-fit">
      <h2 className="text-4xl font-bold inline-block">
        Key <span style={{ color: "#0077cc" }}>Features</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>

    {/* Features List */}
    <ul
      className="list-disc pl-8 space-y-8 text-xl leading-relaxed text-left"
      style={{ color: "#0077cc" }}
    >
      <li>
        <p className="font-semibold text-black">Finance and Accounting:</p>
        <p className="text-gray-800">
          Comprehensive financial tools for budgeting, multi-currency transactions,
          and regulatory compliance.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Inventory and Purchase:</p>
        <p className="text-gray-800">
          Smart inventory tracking with batch/bin management, stock control, and
          automated reordering.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Procurement:</p>
        <p className="text-gray-800">
          End-to-end procurement management, including vendor evaluation,
          tendering, and supply chain optimization.
        </p>
      </li>
    </ul>

  </div>
</section>
<section className="w-full snap-start bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white relative overflow-hidden px-6 sm:px-10 lg:px-16 py-20 !h-auto">
  <div className="max-w-6xl mx-auto flex flex-col w-full">

    {/* Heading */}
    <div className="relative inline-block mb-10 text-left w-fit ml-6 md:ml-10 lg:ml-14">
      <h2 className="text-white text-4xl font-semibold">
        Clinical <span style={{ color: "#0077cc" }}>Support Suite</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-2 h-[6px] object-contain"
      />
    </div>

    {/* Content: Image + Paragraph */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

      {/* Left: Image */}
      <div className="flex justify-start md:justify-start pl-10 lg:pl-14">
        <img
          src={service6}
          alt="WISE HIS illustration"
          className="max-w-[90%] md:max-w-[85%] w-full object-contain"
        />
      </div>

      {/* Right: Paragraph */}
      <div className="flex flex-col justify-center md:pr-6 lg:pr-10">
        <p className="text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-200 text-justify">
          The <span className="font-semibold text-white">WISE HIS Clinical Support Suite</span>
          enhances healthcare operations by integrating essential support services such as
          pharmacy, laboratory, and emergency care. It streamlines critical workflows, ensuring
          seamless coordination between departments and improving patient care delivery.
        </p>
      </div>

    </div>
  </div>
</section>

<section className="w-full snap-start bg-white text-black relative overflow-hidden px-4 sm:px-6 lg:px-8 py-24 !h-auto">
  <div className="max-w-5xl mx-auto flex flex-col w-full">

    {/* Heading */}
    <div className="relative inline-block mb-12 text-left w-fit">
      <h2 className="text-4xl font-bold inline-block">
        Key <span style={{ color: "#0077cc" }}>Features</span>
      </h2>
      <img
        src={line}
        alt="underline"
        className="absolute left-0 -bottom-3 w-full h-[8px] object-contain"
      />
    </div>

    {/* Features List */}
    <ul
      className="list-disc pl-8 space-y-10 text-xl leading-relaxed text-left"
      style={{ color: "#0077cc" }}
    >
      <li>
        <p className="font-semibold text-black">Pharmacy:</p>
        <p className="text-gray-800">
          Centralized drug management system for efficient dispensing, inventory
          tracking, and drug interaction alerts.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Laboratory:</p>
        <p className="text-gray-800">
          End-to-end lab operations management, including specimen tracking,
          automated reporting, and seamless data sharing.
        </p>
      </li>

      <li>
        <p className="font-semibold text-black">Emergency Care:</p>
        <p className="text-gray-800">
          Real-time patient tracking, quick admissions, triage management, and
          graphical representation of patient status.
        </p>
      </li>
    </ul>

  </div>
</section>
<section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden">
  {/* White curved part */}
  <div className="absolute top-[180px] left-0 w-full">
    <div className="bg-white rounded-t-[12rem] sm:rounded-t-[14rem] h-[120vh]"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-24 pb-16">
    {/* Top heading part */}
    <div className="text-center mt-[160px] mb-12">
    <h2
  className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]"
>
  Collaborate for Success
</h2>
      <p className="text-gray-700 text-lg sm:text-xl font-medium">
        Working together with others fosters innovation, creativity, and a greater sense of accomplishment.
      </p>
    </div>

    {/* Four-column footer part */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
      {/* About Us */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
        <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
      <p className="mb-4 leading-relaxed">
  Wissenstil Solutions is a specialized software company driving digital innovation.
</p>
      </div>

      {/* Services */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
        <ul className="space-y-2">
          <li>Image Analysis</li>
          <li>Anomaly Detection</li>
          <li>Medical Coding</li>
        </ul>
      </div>

  
{/* Useful Links */}
<div>
  <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
  <ul
    className="space-y-2 text-gray-800"
    style={{ fontFamily: 'Calibri, sans-serif' }}
  >
    {[
      { name: "About Us", path: "/about" },
      { name: "Wise Services", path: "/services" },
      { name: "Wise Products", path: "/products" },
      { name: "Contact Us", path: "/contact" },
    ].map((link, index) => (
      <li
        key={index}
        className="transition-transform duration-300 hover:translate-x-2 text-base sm:text-lg md:text-xl"
      >
        <Link
          to={link.path}
          onClick={() => (window.location.href = link.path)}
          className="relative inline-block hover:text-purple-700 transition-colors duration-200 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-purple-700 hover:after:w-full after:transition-all after:duration-300"
        >
          {link.name}
        </Link>
      </li>
    ))}
  </ul>
</div>

      {/* Contact */}
      <div>
        <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
        <p>
          Wissenstil Solutions Private Ltd.<br />
          Brigade IRV Centre, 09th &amp; 10th Floor,<br />
          Nallurahalli, Whitefield,<br />
          Bangalore, 560066.
        </p>
     

<div className="mt-4 space-y-3 text-white">
  <p className="flex items-center space-x-3">
    <Phone className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">+91 9986158307</span>
  </p>
  <p className="flex items-center space-x-3">
    <Mail className="w-5 h-5 text-gray-900" />
    <span className="text-gray-900 font-medium">Manish.palliyil@wissenstil.com</span>
  </p>
</div>
      </div>
    </div>
  </div>
</section>

 
    </div>
  );
};
 
export default HisPage;
 
 